import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import {Deslocamento, CustoDeslocamento} from "./deslocamento.model";
import {apiName, apiNameCustosDeslocamento} from "./data.service";

@Injectable()
export class DeslocamentoApiService {
    private includeFilter: any = [{"solicitante":"pessoa"},"bem","area",{"motoristaDesignado": {"funcionario":"pessoa"}},"kmRetorno","kmSaida","destino","tipoViagem"];

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Deslocamento, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Deslocamento, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"dataHoraPrevistaSaida","include":this.includeFilter};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetByFilter(filter: any, done: any) {
        filter.include = this.includeFilter;
        filter.order = "dataHoraPrevistaSaida";
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":this.includeFilter};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetByPassageiro(query: any, done: any) {
        this._restService.onGetPostCustom(apiName + '/populado', query, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //custos
    onPostCustoDeslocamento(object: CustoDeslocamento, done: any) {
        this._restService.onPost(apiNameCustosDeslocamento, object, done);
    }

    onDeleteCustoDeslocamento(objectId: number, done: any) {
        this._restService.onDelete(apiNameCustosDeslocamento, objectId, done);
    }

    onGetCustoDeslocamento(filter: any, done: any) {
        filter.include = ["deslocamento"];
        this._restService.onGetPost(apiNameCustosDeslocamento, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/shared/deslocamento-api.service.ts
 **/